export const BILLING_ATTEMPT_STORAGE_KEY = 'dopatize.billing.subscription-attempt.v1';
export const BILLING_PAYMENT_PENDING_KEY = 'dopatize.billing.payment-pending.v1';

export const billingStorageKey = (baseKey, username) => (
  `${baseKey}:${encodeURIComponent(String(username || 'unknown'))}`
);

const STRIPE_RETURN_PARAMETERS = [
  'payment_intent',
  'payment_intent_client_secret',
  'redirect_status',
];

const safeStorage = () => {
  try {
    const storage = window.localStorage;
    const probeKey = 'dopatize.billing.storage-probe';
    storage.setItem(probeKey, '1');
    storage.removeItem(probeKey);
    return storage;
  } catch (_error) {
    return null;
  }
};

export const readStoredBillingValue = (key) => {
  const storage = safeStorage();
  if (!storage) return null;
  try {
    const value = JSON.parse(storage.getItem(key));
    return value && typeof value === 'object' ? value : null;
  } catch (_error) {
    return null;
  }
};

export const writeStoredBillingValue = (key, value) => {
  const storage = safeStorage();
  if (!storage) return false;
  try {
    storage.setItem(key, JSON.stringify(value));
    return true;
  } catch (_error) {
    return false;
  }
};

export const removeStoredBillingValue = (key) => {
  const storage = safeStorage();
  if (!storage) return;
  try {
    storage.removeItem(key);
  } catch (_error) {
    // Storage cleanup is best-effort.
  }
};

export const secureOperationKey = () => {
  if (typeof window.crypto?.randomUUID === 'function') {
    return window.crypto.randomUUID();
  }
  if (typeof window.crypto?.getRandomValues !== 'function') return null;
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0'));
  return [
    hex.slice(0, 4).join(''),
    hex.slice(4, 6).join(''),
    hex.slice(6, 8).join(''),
    hex.slice(8, 10).join(''),
    hex.slice(10, 16).join(''),
  ].join('-');
};

export const publishableKeyMatchesMode = (key, mode) => (
  typeof key === 'string'
  && (
    (mode === 'test' && key.startsWith('pk_test_'))
    || (mode === 'live' && key.startsWith('pk_live_'))
  )
);

export const sanitizeStripeReturnUrl = (browserWindow = window) => {
  const url = new URL(browserWindow.location.href);
  const containsStripeReturn = STRIPE_RETURN_PARAMETERS.some(
    (parameter) => url.searchParams.has(parameter),
  );
  if (!containsStripeReturn) return false;

  STRIPE_RETURN_PARAMETERS.forEach((parameter) => {
    url.searchParams.delete(parameter);
  });
  const cleanUrl = `${url.pathname}${url.search}${url.hash}`;
  browserWindow.history.replaceState(browserWindow.history.state, '', cleanUrl);
  return true;
};
